module.exports = __webpack_public_path__ + "static/media/5.ccc515fe.jpeg";